<app-progress-bar *ngIf="loading"></app-progress-bar>
<div *ngIf="!loading" class="container">
    <div class="title">
        <h4>Listado de Inscripciones</h4>
        <button type="button" class="btn btn-primary" routerLink="/addinscription">Nueva Inscripción</button>
    </div>

    <table *ngIf="listInscriptions.length > 0" class="table table-hover">
        <thead>
          <tr>
            <th scope="col">CI</th>
            <th scope="col">Nombre</th>
            <th scope="col">Apellidos</th>
            <th scope="col">Carrera</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listInscriptions" class="table-active">
            <td>{{ item.ci }}</td>
            <td>{{ item.namestudent }}</td>
            <td>{{ item.lastnamestudent }}</td>
            <td>{{ item.namecareer }}</td>
            <td>
                <button routerLink="/editinscription/{{item.id}}" type="button" class="btn btn-info btn-sm">Edit</button>
                <button (click)="deleteInscription(item.id!)" type="button" class="btn btn-secondary btn-sm ms-2">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
      <h5 *ngIf="listInscriptions.length == 0">No hay Inscripciones para mostrar</h5>
</div>
